/// <reference types="@angular/localize" />

import { initI18n } from '@shared/lib/i18n/language';

// Translations must be loaded before the app modules are evaluated
// ($localize messages live at module scope), hence the dynamic import.
initI18n()
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err));
